import React, { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';
import router from './features/routing/Routing';
import { startActivityMonitoring, stopActivityMonitoring } from './utils/auth';

export default function App() {
  useEffect(() => {
    const token = localStorage.getItem('token');

    if (token) {
      // Start activity monitoring
      startActivityMonitoring();
    }
    // Cleanup on unmount
    return () => {
      stopActivityMonitoring();
    };
  }, []);

  return <RouterProvider router={router} />;
}
